import { createSelector } from '@reduxjs/toolkit';
import { getStore } from '../../reducers';

const getGoogleBulk = createSelector(getStore, (store) => store.googleBulk);

export const getLinks = createSelector(getGoogleBulk, (googleBulk) => googleBulk.links);

export const getInProgress = createSelector(getGoogleBulk, (googleBulk) => googleBulk.inProgress);

export const getProgressValues = createSelector(
  getGoogleBulk,
  (googleBulk) => googleBulk.progressValues,
);
